// All homepage content lives here so it can be swapped for an API later.

const CDN =
  "https://bathlane-api.91processingunits.workers.dev/img/bathlane-products/aurelia-24-inch-wall-mounted-bathroom-vanity";

export const IMAGES = {
  hero: `${CDN}/hero.webp`,
  wall: `${CDN}/front.webp`,
  floor: `${CDN}/top.webp`,
  p1: `${CDN}/softclose.webp`,
  p2: `${CDN}/storage.webp`,
  p3: `${CDN}/dimentions.webp`,
};

export const CATEGORIES = [
  {
    id: "wall",
    index: "01",
    title: "Wall Mounted",
    subtitle: "Floating. Modern. Space-saving.",
    copy:
      "Clean floating profiles that open up floor space and lend a light, contemporary calm to smaller and mid-size bathrooms.",
    image: IMAGES.wall,
    cta: "Explore Wall Mounted",
    points: [
      "Best for compact & mid-size bathrooms",
      "Floating look, easy to clean under",
    ],
  },
  {
    id: "floor",
    index: "02",
    title: "Floor Mounted",
    subtitle: "Grounded. Practical. Generous storage.",
    copy:
      "Solid, grounded cabinets with larger storage and a reassuring presence — versatile pieces built for everyday family bathrooms.",
    image: IMAGES.floor,
    cta: "Explore Floor Mounted",
    points: [
      "Best for family & larger bathrooms",
      "Grounded feel, generous storage",
    ],
  },
];

export const TRUST = [
  {
    n: "01",
    title: "Vanity-Only Focus",
    copy:
      "A curated collection instead of an endless, cluttered catalogue — every piece is chosen, not just listed.",
  },
  {
    n: "02",
    title: "Correct-Size Buying Help",
    copy:
      "Fit guidance before you order, so the vanity that arrives is the vanity your bathroom was measured for.",
  },
  {
    n: "03",
    title: "Clear Dispatch Timelines",
    copy:
      "Direct coordination with trusted supply partners means honest, transparent dispatch windows.",
  },
  {
    n: "04",
    title: "Installation Support",
    copy:
      "Jaipur installation support, scheduled after delivery confirmation and explained before you book.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Browse the two collections",
    copy: "Start with Wall Mounted or Floor Mounted — the whole catalogue, organised around one clear choice.",
  },
  {
    n: "02",
    title: "Check size & details",
    copy: "Review dimensions, storage and finish. Unsure? We help you confirm the right fit before you commit.",
  },
  {
    n: "03",
    title: "Place your order online",
    copy: "Secure checkout with transparent pricing and a clear dispatch timeline shown up front.",
  },
  {
    n: "04",
    title: "Track dispatch & installation",
    copy: "Receive dispatch updates and schedule Jaipur installation support after delivery confirmation.",
  },
];

export const FAQS = [
  {
    q: "How do I choose the right size?",
    a: "Measure the available wall width, depth and any door or plumbing clearances. Each product lists full dimensions, and our team will confirm the correct fit before you order — just reach out on WhatsApp with your measurements. We size-check every order before dispatch.",
  },
  {
    q: "What if the product arrives damaged?",
    a: "We follow a clear shipping-and-damage process. If a piece arrives damaged, share photos on WhatsApp or email within 48 hours of delivery and we'll guide you through repair, replacement or resolution promptly.",
  },
  {
    q: "Are payments secure and what is your returns policy?",
    a: "Checkout is encrypted and secure, with prices inclusive of taxes and no hidden charges. Returns are supported for eligible unused items per our returns policy; for made-to-configuration pieces we confirm every detail with you before dispatch to avoid returns altogether.",
  },
  {
    q: "What is the difference between wall mounted and floor mounted vanities?",
    a: "Wall mounted vanities float off the floor, creating a lighter, more open feel and easier cleaning underneath — ideal for compact or modern bathrooms. Floor mounted vanities rest on the ground, offering a grounded look with generally larger, more practical storage for family use.",
  },
  {
    q: "Do you keep stock in Jaipur?",
    a: "We coordinate directly with trusted supply partners and show honest dispatch timelines on every product. Availability and lead times are always shown before checkout so there are no surprises.",
  },
  {
    q: "When is installation support scheduled?",
    a: "Jaipur installation support is arranged after delivery is confirmed. The final slot and the scope of support are explained clearly before you book, so expectations are set in advance.",
  },
];

export const REASSURANCE = [
  { title: "Secure Payments", copy: "Trusted, encrypted checkout." },
  { title: "Support on WhatsApp", copy: "Real answers before you buy." },
  { title: "Clear Shipping & Damage", copy: "A transparent, honest process." },
  { title: "Transparent Product Info", copy: "Sizes and timelines, upfront." },
];

export const NAV = [
  { label: "Shop All", type: "route", to: "/vanities" },
  { label: "Wall Mounted", type: "route", to: "/vanities?mount=wall" },
  { label: "Floor Mounted", type: "route", to: "/vanities?mount=floor" },
  { label: "How It Works", type: "anchor", hash: "#how" },
  { label: "Installation", type: "anchor", hash: "#installation" },
  { label: "FAQ", type: "anchor", hash: "#faq" },
];
